import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import styles from './styles.module.scss';
import ChevronRight from '~assets/chevron-right.svg';
import cx from 'classnames';

interface Props {
    title?: string,
    paths: {
        name: string;
        url?: string;
    }[],
    className?: string
}

class OldBreadcrumb extends Component<Props, {}> {
    renderList = (name, classNames?) => {
        return (<div className={`row middle ${classNames}`}>
            <h2 className={`text-small m-right-2 m-left-2 ${classNames}`}>{name}</h2>
        </div>);
    };

    renderLink = () => {
        const {paths} = this.props;
        return paths.map(({name, url}, index, array) => {
            const classNames = index === (array.length - 1) ? styles.firstItem : styles.item;
            return (<>
                {(index > 0) ? <img src={ChevronRight}/> : ''}
                {url ? (
                    <Link to={url} key={name}>
                        {this.renderList(name, classNames)}
                    </Link>
                ) : (
                    <div key={name}>{this.renderList(name, classNames)}</div>
                )}
            </>);
        });
    };

    render() {
        const {title, className} = this.props;
        return <div className={cx(styles.breadcrumb, className)}>
            <div className={styles.breadcrumbLinks}>
                {this.renderLink()}
            </div>
            {title && <div className={styles.breadcrumbTitle}>
                {title}
            </div>}
        </div>;
    }
}

export default OldBreadcrumb;
